/* prettier-ignore-file */
/* eslint-disable */

export const VITE_PORT = import.meta.env.VITE_PORT;
export const VITE_ROUTER_BASENAME = import.meta.env.VITE_ROUTER_BASENAME;
export const VITE_ENV = import.meta.env.VITE_ENV;
export const VITE_BACKEND_REST_URL = import.meta.env.VITE_BACKEND_REST_URL;
export const VITE_MSAL_CLIENT_ID = import.meta.env.VITE_MSAL_CLIENT_ID;
export const VITE_MSAL_TENANT_ID = import.meta.env.VITE_MSAL_TENANT_ID;
export const VITE_API_KEY = import.meta.env.VITE_API_KEY;
